import { useMutation } from "@/core/api/graphql/composables";
import { UpdateCustomerOrderPurchaseOrderNumberDocument } from "@/core/api/graphql/types";

export function useUpdateCustomerOrderPurchaseOrderNumberMutation() {
  return useMutation(UpdateCustomerOrderPurchaseOrderNumberDocument);
}
